import React from 'react';
import { Switch as RNSwitch, SwitchProps as RNSwitchProps } from 'react-native';
import styled from 'styled-components/native';
import { Box } from '@/components/base/box';
import { AppTextView } from '@/components/base/app.text.view';

interface Props extends RNSwitchProps {
  label?: string;
}
function BaseSwitch({ label, ...rest }: Props) {
  return (
    <SwitchContainer>
      <StyledSwitch trackColor={{ false: '#D2D2D2', true: '#00acc1' }} thumbColor={'white'} {...rest} />
      {label && <AppTextView text={label} textColor={'black_light'} />}
    </SwitchContainer>
  );
}

const SwitchContainer = styled(Box)`
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

const StyledSwitch = styled(RNSwitch)`
  height: 35px;
`;

export const AppSwitch = React.memo(BaseSwitch);
